// extracted by mini-css-extract-plugin
export var language = "style-module--language--33cbe";